export default __webpack_public_path__ + "static/media/Portal_Med_Rec.723afe5f.svg";